import { apiRequest } from '../../shared/api/base'

export interface MailContact {
  name: string
  email: string
}

export interface IncomingEmail {
  id: string
  from: MailContact
  subject: string
  preview: string
  source: string
  timestamp: string
  read: boolean
  importance: 'high' | 'normal' | 'low'
  fromSelf: boolean
  assistantAction: string | null
  direction: 'incoming'
}

export interface SentEmail {
  id: string
  to: MailContact
  subject: string
  preview: string
  timestamp: string
  direction: 'outgoing'
}

export type EmailItem = IncomingEmail | SentEmail

export interface EmailListResponse {
  emails: EmailItem[]
  stats: { total: number; processed: number; unread: number; actionRequired: number; quarantined: number }
  nextCursor: string | null
}

export async function getEmails(
  direction: 'incoming' | 'outgoing' = 'incoming',
  limit = 20,
  cursor?: string,
): Promise<EmailListResponse> {
  const params = new URLSearchParams({ direction, limit: String(limit) })
  if (cursor) params.set('cursor', cursor)
  return apiRequest<EmailListResponse>(`/inbox/emails?${params}`)
}
